import { AppRoute } from '../models';
import { ACLType } from 'modules/authorization';
import { lazyNamed } from 'utils';

const publicRoutes: AppRoute[] = [
  {
    key: 'home',
    access: ACLType.AnonymousOnly,
    Element: lazyNamed(() => import('views/Home'), 'Home'),
    title: 'TeamMak',
    path: '/',
  },
  {
    key: 'contact',
    access: ACLType.Public,
    Element: lazyNamed(() => import('views/Contact'), 'Contact'),

    title: 'TeamMak',
    path: '/contact',
  },
  {
    key: 'login',
    access: ACLType.AnonymousOnly,
    Element: lazyNamed(() => import('views/Login'), 'Login'),
    title: 'Login',
    path: '/login',
  },
  {
    key: 'register',
    access: ACLType.AnonymousOnly,
    Element: lazyNamed(() => import('views/Register'), 'Register'),
    title: 'Register',
    path: '/register',
  },
  {
    key: 'forgot-password',
    access: ACLType.AnonymousOnly,
    Element: lazyNamed(() => import('views/ForgotPassword'), 'ForgotPassword'),
    title: 'Forgot Password',
    path: '/forgot-password',
  },
  {
    key: 'terms-and-conditions',
    access: ACLType.Public,
    Element: lazyNamed(() => import('views/TermsAndConditions'), 'TermsAndConditions'),
    title: 'Terms and conditions',
    path: '/terms-and-conditions',
  },
  {
    key: 'privacy-policy',
    access: ACLType.Public,
    Element: lazyNamed(() => import('views/PrivacyPolicy'), 'PrivacyPolicy'),
    title: 'Privacy policy',
    path: '/privacy-policy',
  },
  {
    key: 'shared',
    access: ACLType.Public,
    Element: lazyNamed(() => import('views/PublicAudioDetails'), 'PublicAudioDetails'),
    title: 'Shared audio',
    path: '/shared/:shareId',
  },
];

export default publicRoutes;
